import { render, staticRenderFns } from "./pile.vue?vue&type=template&id=05cd0643&scoped=true&"
import script from "./pile.vue?vue&type=script&lang=js&"
export * from "./pile.vue?vue&type=script&lang=js&"
import style0 from "./pile.vue?vue&type=style&index=0&id=05cd0643&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cd0643",
  null
  
)

export default component.exports